
(function paycheckEditControllerDefinition() {
    'use strict';

    angular.module('Paycheck')
        .controller('PaycheckEditController', [
            '$filter', '$state', '$scope', '$stateParams', 'errorsExtend', 'processCustomerService', 'fileWorkflowService', 'authExtend', 'configViewService', '$q', '$window', 'adminOrganizationalUnitService', 'profileCertificateService', '$parse', 'fileService', 'config',
            function paycheckEditController($filter, $state, $scope, $stateParams, errors, processCustomerService, fileWorkflowService, auth, configViewService, $q, $window, adminOrganizationalUnitService, profileCertificateService, $parse, fileService, config) {

                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.legend = { type: 'warning', message: 'NoCertificateAvailable' };
                $scope.callbackUrl = '#/Paycheck/Find/SignPending';

                $scope.tmpProcess = {
                    name: '',
                    metadatas: []
                };

                $scope.setPaycheck = function (paycheck) {
                    $scope.paycheck = paycheck;
                    return adminOrganizationalUnitService.getConfigs(paycheck.organizationalUnitId);
                };

                $scope.loadConfig = function (configs) {
                    var paycheckType = $filter('filter')($scope.paycheck.metadataValues, { systemName: '_trec' }, true);
                    var config = $filter('filter')(configs, function (item) {
                        return paycheckType.length > 0 && item.configName === '#OuConfigRA' + paycheckType[0].value;
                    }, true);

                    if (config.length === 0) {
                        config = $filter('filter')(configs, { configName: '#OuConfigSectionPaychecks' }, true);
                    }

                    if (config.length > 0) {
                        var metadata = $filter('filter')(config[0].metatadataValues, { name: '#PaycheckMotiveDisagreement' }, true);
                        if (metadata.length > 0) {
                            $scope.showMotiveDisagreement = metadata[0].value === 'true';
                            $scope.disagreementMotive = '';
                        }
                    }

                    var certificateFilters = {
                        organizationalUnitId: $scope.paycheck.organizationalUnitId,
                        enabled: true,
                        active: true,
                        type: 0, // Empleado
                        signType: 0 // Firma simple
                    };

                    return $q.all([configViewService.getById('CPPPaycheck'), profileCertificateService.get(certificateFilters)]);
                };

                $scope.setConfig = function (result) {
                    $scope.configView = result[0];
                    var metadatas = [];
                    var processType = $filter('filter')($scope.configView.processTypes, { processTypeId: $scope.paycheck.paycheckTypeId }, true);
                    if (processType.length == 0) {
                        $scope.paycheck.metadataValues = metadatas;
                        return;
                    }

                    processType[0].metadatas.forEach(function (paycheckMetadata) {
                        if (paycheckMetadata.editCriteria) {
                            var metadataFound = $filter('filter')($scope.paycheck.metadataValues, { systemName: paycheckMetadata.systemName }, true);
                            var value = null;
                            var desc = null;
                            var isVisible = true;

                            if (metadataFound.length > 0) {
                                value = metadataFound[0].value;
                                desc = metadataFound[0].description;
                            }

                            if (paycheckMetadata.systemName === '_motivodisc' ||
                                paycheckMetadata.systemName === '_modFirma' ||
                                paycheckMetadata.systemName === '_estrec' ||
                                paycheckMetadata.systemName === '_idCertificado' ||
                                paycheckMetadata.systemName === '_cpassword') {
                                isVisible = false;
                            }

                            $scope.tmpProcess.metadatas.push({
                                idObject: $scope.paycheck.id + '' + paycheckMetadata.metadataId,
                                metadataId: paycheckMetadata.metadataId,
                                metadataType: paycheckMetadata.metadataType.toLowerCase(),
                                metadataLabel: paycheckMetadata.editCriteria.name,
                                metadataIsRequired: paycheckMetadata.editCriteria.isRequired && isVisible,
                                metadataIsVisible: isVisible,
                                metadataReadOnly: !paycheckMetadata.editCriteria.isEditable,
                                metadataEnabled: paycheckMetadata.editCriteria.isEditable,
                                maskOptions: paycheckMetadata.metadataMaskOption,
                                metadataValue: value,
                                metadataOptions: paycheckMetadata.metadataOptionValues,
                                systemName: paycheckMetadata.systemName,
                                order: paycheckMetadata.editCriteria.order
                            });
                        }
                    });

                    if (result[1].length > 0) {
                        $scope.addCertificateMetadata(result[1]);
                    } else {
                        $scope.signNoCertificate = true;
                    }

                    $scope.tmpProcess.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    var item = {};

                    $scope.paycheck.files.forEach(function (file) {
                        item.creationDate = file.creationDate;
                        item.name = file.name;
                        item.size = file.size;
                        item.id = file.id;
                        item.stream = null;
                    });

                    $scope.previewFile(item, 0);
                };

                $scope.controlChanged = function (metadata) {
                    if (metadata.systemName === '_wcertificate') {
                        var selectedOption = $filter('filter')(metadata.metadataOptions, { value: metadata.metadataValue }, true);
                        if (selectedOption.length === 1) {
                            $scope.selectedCertificate = selectedOption[0];
                            $scope.disagreementIsEnabled = $scope.selectedCertificate.supportDisagreement;
                            $scope.isNacion = $scope.selectedCertificate.description === 'Nacion';
                            $scope.certId = $scope.selectedCertificate.id;

                            angular.forEach($scope.tmpProcess.metadatas, function (m) {
                                if (m.systemName === '_cpassword') {
                                    m.metadataIsVisible = $scope.selectedCertificate.requirePassword;
                                    m.metadataIsRequired = $scope.selectedCertificate.requirePassword;
                                    m.metadataValue = undefined;
                                }

                                if (m.systemName === '_idCertificado') {
                                    m.metadataValue = $scope.selectedCertificate.id;
                                }
                            });
                        }
                    }

                    if (metadata.systemName === '_motivodisc') {
                        $scope.disagreementMotive = metadata.metadataValue;
                    }
                };

                $scope.showError = function (error) {
                    errors.showError(error);
                    $scope.cancel();
                };

                $scope.previewFile = function (item, index) {
                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;

                    fileWorkflowService.preview(item, true).then(function (result) {
                        $scope.preview.content = result;

                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        } else {
                            errors.showError(error);
                            //$scope.hidePreview();
                        }
                    });
                };

                $scope.showDisagreement = function (value) {
                    $scope.disagreementIsVisible = value;
                    $scope.disagreementMotive = $scope.showMotiveDisagreement ? '' : undefined;

                    $scope.tmpProcess.metadatas.forEach(function (metadata) {
                        if (metadata.systemName === '_motivodisc') {
                            metadata.metadataIsVisible = $scope.disagreementIsVisible && $scope.showMotiveDisagreement;
                            metadata.metadataIsRequired = $scope.disagreementIsVisible && $scope.showMotiveDisagreement;
                            metadata.metadataValue = undefined;
                        }
                    });
                };

                $scope.addCertificateMetadata = function (certificates) {
                    var metadataCertificates = {
                        idObject: $scope.paycheck.id + '_wcertificate',
                        systemName: '_wcertificate',
                        metadataType: 'radio',
                        metadataLabel: 'Certificado',
                        metadataIsVisible: certificates.length > 1,
                        metadataEnabled: certificates.length > 1,
                        metadataIsRequired: true,
                        metadataValue: undefined,
                        metadataOptions: []
                    };

                    angular.forEach(certificates, function (certificate) {
                        var description = certificate.provider;
                        if (certificate.expirationDate) {
                            description = certificate.provider + ' (' + $filter('date')(certificate.expirationDate, 'dd/MM/yyyy') + ')';
                        }

                        metadataCertificates.metadataOptions.push({
                            id: certificate.id,
                            value: certificate.id,
                            description: description,
                            requirePassword: certificate.requirePassword,
                            supportDisagreement: certificate.supportDisagreement,
                            action: certificate.singleSignatureAction
                        });
                    });

                    if (metadataCertificates.metadataOptions.length === 1) {
                        metadataCertificates.metadataValue = metadataCertificates.metadataOptions[0].value;
                        $scope.controlChanged(metadataCertificates);
                    }

                    $scope.tmpProcess.metadatas.push(metadataCertificates);
                };

                $scope.cancel = function () {
                    if (!$scope.disagreementIsVisible) {
                        $window.history.back();
                    }

                    $scope.showDisagreement(false);
                };

                $scope.execute = function () {
                    if (!$scope.paycheckEdit.$valid) {
                        $scope.paycheckEdit.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    if (!$scope.selectedCertificate.action) {
                        errors.showWarning('CertificateProviderNotConfigured');
                        return false;
                    }

                    var method = $parse($scope.selectedCertificate.action);

                    if (!method($scope)) {
                        errors.showWarning('CertificateProviderNotConfigured');
                        return false;
                    }

                    return method($scope)();
                };

                $scope.signEncode = function () {
                    $scope.tmpProcess.metadatas.forEach(function (tmpProcessMetadata) {

                        var metadataFound = $filter('filter')($scope.paycheck.metadataValues, { metadataId: tmpProcessMetadata.metadataId }, true);

                        if (tmpProcessMetadata.systemName === '_estrec') {
                            tmpProcessMetadata.metadataValue = $scope.disagreementIsVisible ? 'NC' : 'C';
                        }

                        if (metadataFound.length === 1) {
                            metadataFound[0].value = tmpProcessMetadata.metadataValue;
                        } else if (metadataFound.length === 0) {
                            $scope.paycheck.metadataValues.push({
                                metadataId: tmpProcessMetadata.metadataId,
                                name: tmpProcessMetadata.metadataLabel,
                                isRequired: tmpProcessMetadata.metadataIsRequired,
                                isVisible: tmpProcessMetadata.metadataIsVisible,
                                order: tmpProcessMetadata.order,
                                systemName: tmpProcessMetadata.systemName,
                                type: tmpProcessMetadata.metadataType,
                                value: tmpProcessMetadata.metadataValue
                            });
                        }
                    });

                    return processCustomerService.modifyAndSend($scope.paycheck).then(function () {
                        $state.go('paycheck-find');
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.load = function () {
                    $scope.signPermission = auth.isInRole('PAYCHECKCUSTOMER SIGN');
                    $scope.showMotiveDisagreement = false;
                    $scope.disagreementIsVisible = false;
                    $scope.disagreementIsEnabled = false;

                    processCustomerService.checkout($stateParams.id)
                        .then($scope.setPaycheck, $scope.showError)
                        .then($scope.loadConfig, $scope.showError)
                        .then($scope.setConfig, $scope.showError);
                };

                $scope.signLakaut = function () {
                    errors.showError('ProviderNotSuportted');
                }

                $scope.load();
            }
        ]);
})();
